<template>
  <div class="page-main">
    <div class="flex flex-y-center flex-x-between m-b-10">
      <div class="flex flex-y-center">
        <el-button type="success" size="mini" icon="el-icon-plus" @click="itemDoApply()"
          >新增采购申请单
        </el-button>
        <el-dropdown class="m-l-10">
          <el-button type="default" size="mini">
            批量操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="batchCreateOrder">
              <span class="c-green">生成采购订单</span>
            </el-dropdown-item>
            <el-dropdown-item @click.native="batchDelete">
              <span class="c-red">删除</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-form class="flex flex-y-center m-l-10" @submit.native.prevent="searchListData">
          <span>申请日期:</span>
          <e-date-picker
            type="daterange"
            :value.sync="shen_gou_date"
            isShowFast
            @change="searchListData"
          />
        </el-form>
        <!-- 一键清空所有表头筛选 -->
        <el-button
          size="mini"
          icon="el-icon-refresh"
          class="m-l-10"
          :disabled="!hasFilter"
          @click="resetFilter"
          >重置筛选
        </el-button>
      </div>
    </div>
    <!-- 表格 -->
    <vxe-grid
      ref="refTable"
      :show-footer="!!tableData.length"
      :loading="loading"
      :columns="tableColumn"
      :data="tableData"
      :height="this.$util.getViewHeight() - 36 - 148"
      :footer-method="footerMethod"
      :cell-class-name="cellClassName"
      @cell-dblclick="itemDbDo"
      @resizable-change="handleColumnResize"
      @keydown="tableKeydown"
      @current-change="tableCurrentChange"
    >
      <!-- slot_header 表头筛选 -->
      <template #header_input="{ column }">
        <c-table-header
          :title="column.title"
          :field="column.field"
          :url="headerFilterUrl"
          :filterData="filterData"
          :value="filterData[column.field]"
          placeholder="输入关键字"
          @change="headerFilterChange"
        />
      </template>
      <!-- 是否已打印-筛选 -->
      <template #header_is_print="{ column }">
        <div class="header-filter-box">
          <div>{{ column.title }}</div>
          <el-select
            v-model="filterData.is_print"
            size="mini"
            placeholder="全部"
            clearable
            style="width: 80px"
            @change="searchListData"
          >
            <el-option label="已打印" value="1" />
            <el-option label="未打印" value="0" />
          </el-select>
        </div>
      </template>

      <!-- slot_default -->
      <template #default_shen_gou_code="{ row }">
        <el-link type="primary" @click="itemDoApply(row.shen_gou_code)">
          {{ row.shen_gou_code }}
        </el-link>
      </template>
      <template #default_shen_gou_date="{ row }">
        {{ row.shen_gou_date ? row.shen_gou_date.slice(0, 10) : '' }}
      </template>
      <template #default_create_date="{ row }">
        {{ row.create_date_str || (row.create_date ? row.create_date.slice(0, 10) : '') }}
      </template>
      <template #default_shen_qing_ren_name="{ row }">
        <div>{{ row.shen_qing_ren_name }}</div>
        <div v-if="row.shen_qing_bu_men_name" class="c-gray">({{ row.shen_qing_bu_men_name }})</div>
      </template>
      <template #default_qi_wang_date="{ row }">
        {{ row.qi_wang_date_str || (row.qi_wang_date ? row.qi_wang_date.slice(0, 10) : '') }}
      </template>
      <template #default_list_chan_pin_tu="{ row }">
        <e-upload-image v-if="row.list_chan_pin_tu" :list.sync="row.list_chan_pin_tu" disabled />
      </template>
      <template #default_shen_gou_amount="{ row }">
        <span class="c-orange">{{ row.shen_gou_amount }}</span>
      </template>
      <!-- 是否已打印-显示 -->
      <template #default_is_print="{ row }">
        <el-tag v-if="row.is_print" type="success" size="mini">已打印</el-tag>
        <el-tag v-else type="danger" size="mini">未打印</el-tag>
      </template>
      <template #default_status_str="{ row }">
        <el-tag :type="statusTagType(row.status)" size="mini" plain>{{ row.status_str }}</el-tag>
      </template>
      <template #default_transfer_status="{ row }">
        <el-tag :type="transferTagType(row.transfer_status)" size="mini" plain>
          {{ row.transfer_status }}
        </el-tag>
      </template>
      <template #default_operate="{ row }">
        <el-dropdown>
          <el-button type="default" size="mini">
            操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-if="canEdit(row)" @click.native="itemDoApply(row.shen_gou_code)">
              <span class="c-blue">编辑</span>
            </el-dropdown-item>
            <el-dropdown-item
              v-if="canSubmit(row) && $tool.hasControl(['/shengou3/submit'])"
              @click.native="itemSubmit(row)"
            >
              <span class="c-blue">提交</span>
            </el-dropdown-item>
            <el-dropdown-item
              v-if="canAudit(row) && $tool.hasControl(['/shengou3/audit'])"
              @click.native="itemAudit(row)"
            >
              <span class="c-green">审核</span>
            </el-dropdown-item>
            <el-dropdown-item
              v-if="canUnaudit(row) && $tool.hasControl(['/shengou3/unaudit'])"
              @click.native="itemUnaudit(row)"
            >
              <span class="c-blue">反审核</span>
            </el-dropdown-item>
            <el-dropdown-item
              v-if="canCancel(row) && $tool.hasControl(['/shengou3/cancel'])"
              @click.native="itemCancel(row)"
            >
              <span class="c-gray">作废</span>
            </el-dropdown-item>
            <el-dropdown-item
              v-if="canCreateOrder(row) && $tool.hasControl(['/caiGouDingDan/createFromShenGou'])"
              @click.native="itemCreateOrder(row)"
            >
              <span class="c-green">生成采购订单</span>
            </el-dropdown-item>
            <el-dropdown-item @click.native="itemPrint(row.shen_gou_code)">
              <span class="c-gray">打印</span>
            </el-dropdown-item>
            <el-dropdown-item
              v-if="isAdmin && canEdit(row)"
              @click.native="
                itemDelete({ ids: [row.shen_gou_bill_id], codes: [row.shen_gou_code] })
              "
            >
              <span class="c-red">删除</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </template>

      <!-- slot_pager -->
      <template #pager>
        <div></div>
        <vxe-pager v-bind="pageOptions" @page-change="pageChange" />
      </template>
    </vxe-grid>

    <!-- 弹窗-新增采购申请单 -->
    <PopupApplyDo
      v-if="isShowPopupApplyDo"
      :show.sync="isShowPopupApplyDo"
      :code="activeCode"
      @success="updatePage"
    />
  </div>
</template>

<script>
export default {
  tableName: 'new_purchase_apply_page_list',
  components: {
    PopupApplyDo: () => import('../common/popup-do')
  },
  data() {
    return {
      // loading
      loading: true,

      // filter（预定义全部表头筛选字段，保证 Vue2 响应式）
      shen_gou_date: [],
      filterData: {
        shen_gou_code: '',
        shen_gou_type: '',
        status_str: '',
        shen_qing_ren_name: '',
        bill_code: '',
        gong_cheng_fu_ze_ren_name: '',
        pmc_fu_ze_ren_name: '',
        supplier_name: '',
        supplier_fu_ze_ren: '',
        supplier_phone: '',
        name: '',
        wu_liao_type: '',
        spec: '',
        unit: '',
        shen_gou_counts: '',
        ordered_counts: '',
        un_ordered_counts: '',
        transfer_status: '',
        goods_price: '',
        shen_gou_amount: '',
        remark: '',
        is_print: '',
        qi_wang_date_str: '',
        create_date_str: ''
      },
      sortData: {
        create_date: 'desc',
        a_id: 'desc'
      },

      // table
      tableData: [],
      pageOptions: {
        ...this.$constant.page
      },
      totalObj: {
        shen_gou_counts_all: '',
        shen_gou_amount_all: ''
      },

      // popup
      isShowPopupApplyDo: false,
      activeBillId: null,
      activeCode: null
    }
  },
  computed: {
    // 是否存在已生效的表头筛选条件
    hasFilter() {
      let result = Object.keys(this.filterData).some((key) => {
        let val = this.filterData[key]
        return val !== '' && val !== null && val !== undefined
      })
      return result
    },
    // 是否是管理员
    isAdmin() {
      let result = this.$store.getters.getRoleObj.isAdmin
      return result
    },
    // 当前登录账号id
    accountId() {
      return this.$store.state.loginAccount.id
    },
    // 表头联想筛选接口
    headerFilterUrl() {
      return '/admin/gcvip/shengou3/searchHeard'
    },
    // 表格列
    tableColumn() {
      let result = [
        {
          fixed: 'left',
          type: 'checkbox',
          width: 40
        },
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          fixed: 'left',
          title: '采购申请单号',
          field: 'shen_gou_code',
          slots: { header: 'header_input', default: 'default_shen_gou_code' },
          width: 110
        },
        {
          title: '采购类型',
          field: 'shen_gou_type',
          slots: { header: 'header_input' }
        },
        {
          title: '状态',
          field: 'status_str',
          width: 90,
          slots: { header: 'header_input', default: 'default_status_str' }
        },
        {
          title: '申请日期',
          field: 'shen_gou_date',
          slots: { default: 'default_shen_gou_date' }
        },
        {
          title: '创建日期',
          field: 'create_date_str',
          slots: { header: 'header_input', default: 'default_create_date' }
        },
        {
          title: '申请人',
          field: 'shen_qing_ren_name',
          slots: { header: 'header_input', default: 'default_shen_qing_ren_name' }
        },
        {
          title: '期望交期',
          field: 'qi_wang_date_str',
          slots: { header: 'header_input', default: 'default_qi_wang_date' }
        },
        {
          title: '销售单号',
          field: 'bill_code',
          slots: { header: 'header_input' }
        },
        {
          title: '工程负责人',
          field: 'gong_cheng_fu_ze_ren_name',
          width: 100,
          slots: { header: 'header_input' }
        },
        {
          title: 'PMC负责人',
          field: 'pmc_fu_ze_ren_name',
          width: 100,
          slots: { header: 'header_input' }
        },
        {
          title: '供应商',
          field: 'supplier_name',
          slots: { header: 'header_input' }
        },
        {
          title: '供应商负责人',
          field: 'supplier_fu_ze_ren',
          width: 100,
          slots: { header: 'header_input' }
        },
        {
          title: '供应商电话',
          field: 'supplier_phone',
          slots: { header: 'header_input' }
        },
        {
          title: '物料图片',
          field: 'list_chan_pin_tu',
          slots: { default: 'default_list_chan_pin_tu' },
          width: 63
        },
        {
          title: '物料名称',
          field: 'name',
          slots: { header: 'header_input' }
        },
        {
          title: '物料类型',
          field: 'wu_liao_type',
          slots: { header: 'header_input' }
        },
        {
          title: '规格(mm)',
          field: 'spec',
          width: 120,
          slots: { header: 'header_input' }
        },
        {
          title: '单位',
          field: 'unit',
          slots: { header: 'header_input' }
        },
        {
          title: '本次申购数量',
          field: 'shen_gou_counts',
          width: 100,
          slots: { header: 'header_input' }
        },
        {
          title: '已下单数量',
          field: 'ordered_counts',
          width: 95,
          slots: { header: 'header_input' }
        },
        {
          title: '可转数量',
          field: 'un_ordered_counts',
          width: 85,
          slots: { header: 'header_input' }
        },
        {
          title: '转单状态',
          field: 'transfer_status',
          width: 90,
          slots: { header: 'header_input', default: 'default_transfer_status' }
        },
        {
          title: '单价(元)',
          field: 'goods_price',
          slots: { header: 'header_input' }
        },
        {
          title: '金额(元)',
          field: 'shen_gou_amount',
          slots: { header: 'header_input', default: 'default_shen_gou_amount' }
        },
        {
          title: `备注`,
          field: 'remark',
          width: 160,
          slots: { header: 'header_input' }
        },
        {
          fixed: 'right',
          title: '是否已打印',
          field: 'is_print',
          width: 110,
          slots: { header: 'header_is_print', default: 'default_is_print' }
        },
        {
          fixed: 'right',
          title: '操作',
          field: 'operate',
          slots: { default: 'default_operate' },
          width: 73
        }
      ]
      this.$util.initTableColumnWidth(this.$options.tableName, result, 'inherit')
      return result
    }
  },
  mounted() {
    this.getListData()
  },
  methods: {
    // 列宽变化，保存单列宽度
    handleColumnResize({ column }) {
      this.$util.setTableColumnWidth(this.$options.tableName, column.field, column.resizeWidth)
    },
    // 更新页面
    updatePage() {
      this.searchListData()
    },
    // 表头筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.searchListData()
    },
    // 重置表头筛选并刷新列表
    resetFilter() {
      this.resetFilterData()
      this.searchListData()
    },
    // 重置表头筛选
    resetFilterData() {
      Object.keys(this.filterData).forEach((key) => {
        this.filterData[key] = ''
      })
    },
    // 搜索列表数据
    searchListData() {
      this.pageOptions.currentPage = 1
      this.getListData()
    },
    // 获取列表数据
    getListData() {
      this.loading = true
      let params = {
        currentPage: this.pageOptions.currentPage,
        pageSize: this.pageOptions.pageSize,
        shen_gou_date: this.shen_gou_date || [],
        filterData: this.filterData,
        sortData: this.$util.deepCopy(this.sortData)
      }

      this.$api({
        method: 'post',
        url: '/admin/gcvip/shengou3/list',
        data: params
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            let data = res.data.page
            let list = this.$util.deepCopy(data.list)
            list.forEach((item) => {
              item.isYinYong = this.isAdmin || item.saler_id === this.accountId
              item.isChuangJian = this.isAdmin || item.saler_id === this.accountId
              item.isFuZe = this.isAdmin || item.fu_ze_ren_id === this.accountId
            })
            this.tableData = list

            this.pageOptions.pageSize = data.pageSize
            this.pageOptions.total = data.totalRow
            this.pageOptions.currentPage = data.pageNumber

            this.totalObj.shen_gou_counts_all = res.data.shen_gou_counts_all
            this.totalObj.shen_gou_amount_all = res.data.shen_gou_amount_all
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 分页切换
    pageChange({ currentPage, pageSize }) {
      this.pageOptions.currentPage = currentPage
      this.pageOptions.pageSize = pageSize
      this.getListData()
    },
    // 获取-当前单选行
    getCheckboxRecords() {
      return this.$refs.refTable.getCheckboxRecords()
    },
    // 表格-高亮行更改
    tableCurrentChange(params) {
      this.$refs.refTable.setCheckboxRow(params.row, true) // 选中checkbox
    },
    // 表格-键盘空格
    tableKeydown(params) {
      if (params.$event.code === 'Space') {
        let row = this.$refs.refTable.getCurrentRecord()
        let isCurrentRowCheckbox = this.$refs.refTable.isCheckedByCheckboxRow(row)
        this.$refs.refTable.setCheckboxRow(row, !isCurrentRowCheckbox) // 选中checkbox
      }
    },
    // 项-选择提示
    itemChoosePrompt() {
      this.$tool.tableChoosePrompt()
    },
    // 表格底部
    footerMethod({ columns }) {
      return [
        columns.map((column, columnIndex) => {
          if (columnIndex === 0) return '合计'
          if (column.field === 'shen_gou_counts') return this.totalObj.shen_gou_counts_all
          if (column.field === 'shen_gou_amount') return this.totalObj.shen_gou_amount_all
        })
      ]
    },
    // 行类名计算，实现按字段分组的斑马纹效果
    cellClassName(rowData) {
      let result = this.$tool.getTableCellClassName(this.tableData, rowData, 'shen_gou_code')
      return result
    },
    // 项-增改-采购申请
    itemDoApply(code = null) {
      this.activeCode = code
      this.isShowPopupApplyDo = true
    },
    // 项-双击增改
    itemDbDo(val) {
      this.itemDoApply(val.row.shen_gou_code)
    },
    // 项-打印
    itemPrint(code) {
      window.open(`/new/purchase/apply/print?code=${code}`, '_blank')
    },
    // 状态标签样式：0草稿 1待审核 2已审核 3已作废
    statusTagType(status) {
      if (status === 2) return 'success'
      if (status === 1) return 'warning'
      return 'info'
    },
    // 转单状态标签样式
    transferTagType(transferStatus) {
      if (transferStatus === '已转单') return 'success'
      if (transferStatus === '部分转单') return 'warning'
      return 'info'
    },
    canEdit(row) {
      return row.status === 0 || row.status === 1
    },
    canSubmit(row) {
      return row.status === 0
    },
    canAudit(row) {
      return row.status === 0 || row.status === 1
    },
    canUnaudit(row) {
      return row.status === 2
    },
    canCancel(row) {
      return row.status === 0 || row.status === 1
    },
    // 可生成采购订单：已审核且仍有可转数量
    canCreateOrder(row) {
      return row.status === 2 && Number(row.un_ordered_counts || 0) > 0
    },
    // 项-生成采购订单（按当前行）
    itemCreateOrder(row) {
      this.createOrder([row.b_id])
    },
    // 批量-生成采购订单
    batchCreateOrder() {
      let rows = this.getCheckboxRecords()
      if (!rows.length) {
        this.itemChoosePrompt()
        return
      }
      if (rows.some((r) => !this.canCreateOrder(r))) {
        this.$message.warning('仅已审核且仍有可转数量的采购申请明细可生成采购订单')
        return
      }
      this.createOrder(rows.map((r) => r.b_id))
    },
    // 生成采购订单（按行转单，后端按剩余可转数量全额下单）
    createOrder(itemIds) {
      let ids = [...new Set(itemIds.filter(Boolean))]
      if (!ids.length) {
        this.$message.warning('请先选择采购申请明细')
        return
      }
      this.$confirm('确定按所选明细生成采购订单吗（默认按剩余可转数量全额下单）?', '提示')
        .then(() => {
          this.$api({
            method: 'post',
            url: '/admin/gcvip/caiGouDingDan/createFromShenGou',
            data: { itemIds: ids }
          })
            .then((res) => {
              if (res.data.state === 'ok') {
                this.$message.success(`已生成采购订单 ${res.data.code}`)
                this.getListData()
                this.$confirm(
                  `采购订单 ${res.data.code} 已生成，是否前往采购订单列表查看?`,
                  '提示',
                  { confirmButtonText: '前往', cancelButtonText: '留在本页' }
                )
                  .then(() => {
                    this.$router.push('/new/purchase/order/list')
                  })
                  .catch(() => {})
              } else if (res.data.msg) {
                this.$message.error(res.data.msg)
              }
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    // 项-提交
    itemSubmit(row) {
      this.$confirm(`确定提交采购申请"${row.shen_gou_code}"吗?`, '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/gcvip/shengou3/submit',
            params: { id: row.a_id }
          })
            .then((res) => {
              this.handleActionRes(res, '提交成功')
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    // 项-审核
    itemAudit(row) {
      this.$confirm(`确定审核采购申请"${row.shen_gou_code}"吗?`, '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/gcvip/shengou3/audit',
            params: { id: row.a_id }
          })
            .then((res) => {
              this.handleActionRes(res, '审核成功')
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    // 项-反审核
    itemUnaudit(row) {
      this.$confirm(`确定反审核采购申请"${row.shen_gou_code}"吗?`, '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/gcvip/shengou3/unaudit',
            params: { id: row.a_id }
          })
            .then((res) => {
              this.handleActionRes(res, '反审核成功')
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    // 项-作废
    itemCancel(row) {
      this.$confirm(`确定作废采购申请"${row.shen_gou_code}"吗?`, '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/gcvip/shengou3/cancel',
            params: { id: row.a_id }
          })
            .then((res) => {
              this.handleActionRes(res, '作废成功')
            })
            .catch(() => {})
        })
        .catch(() => {})
    },
    // 批量-删除
    batchDelete() {
      let rows = this.getCheckboxRecords()
      if (rows.length) {
        if (rows.some((r) => !this.canEdit(r))) {
          this.$message.warning('存在已审核/已作废单据，无法删除')
          return
        }
        let ids = rows.map((item) => item.shen_gou_bill_id)
        let codes = rows.map((item) => item.shen_gou_code)

        let obj = {
          ids: [...new Set(ids)],
          codes: [...new Set(codes)]
        }
        this.itemDelete(obj)
      } else {
        this.itemChoosePrompt()
      }
    },
    // 项-删除
    itemDelete(obj) {
      this.$confirm(`您确定要删除编码为"${obj.codes.join(',')}"的采购申请单吗?`, '提示')
        .then(() => {
          this.deleteConfirm(obj.ids)
        })
        .catch(() => {})
    },
    // 项-删除-确认
    deleteConfirm(ids) {
      this.$api({
        method: 'get',
        url: '/admin/gcvip/shengou3/delete',
        params: {
          ids: ids.join(',')
        }
      })
        .then((res) => {
          if (res.data.state === 'ok') {
            this.$message.success('操作成功')
            this.getListData()
          }
        })
        .catch(() => {})
    },
    handleActionRes(res, okMsg) {
      if (res.data.state === 'ok') {
        this.$message.success(res.data.msg || okMsg)
        this.getListData()
      } else if (res.data.msg) {
        this.$message.error(res.data.msg)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.page-main {
}
// 是否已打印-表头筛选容器（参考 renwu 列表实现）
.header-filter-box {
  color: @colorGrayDeep;
  .el-select {
    margin-top: 2px;
    /deep/ .el-input__inner {
      height: 24px;
      line-height: 24px;
      color: @colorGrayDeep;
      width: 100% !important;
      overflow: hidden;
      padding: 0 2px;
      text-align: center;
    }
    // 下拉箭头图标随输入框高度垂直居中
    /deep/ .el-input__icon {
      width: auto;
      line-height: 24px;
    }
    // 箭头区域白底，避免与居中文字重叠时透底
    /deep/ .el-input__suffix-inner {
      background: #fff;
    }
  }
}
</style>
